<template>
    <modal
        name="login-modal"
        :click-to-close="true"
        height="auto"
        @before-open="beforeOpen"
        :scrollable="true"
        :adaptive="true"
    >
        <form @submit.prevent="login()" method="post" id="sign-in-form">
            <div id="log-in-modal">
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <button @click="closeLoginModal()" type="button" class="close text-white text-light" aria-label="Close">
                                <i class="modal-close" />
                            </button>
                        </div>
                        <div class="modal-body text-light">
                            <h3 class="modal-title text-white m-b" id="log-in-modal-label">SIGN IN</h3>

                            <!-- We need to fake these fields to avoid the Chrome autofill in the real fields-->
                            <input style="display: none;" type="email" name="email" id="fake-email-field-1">
                            <input style="display: none;" type="text" name="password" id="fake-password-field-1">

                            <div class="form m-b-md">
                                <div class="form-group field" :class="{'has-error': 'error'}">
                                    <input
                                        v-model.lazy="email"
                                        placeholder="Email Address"
                                        type="email"
                                        class="form-control"
                                        v-validate="'required|email'"
                                        :class="{'input': true, 'danger': errors.has('email') }"
                                        name="email"
                                    >
                                    <span v-show="errors.has('email') || error" class="vv-error-message">
                                        {{ errors.first('email') || error }}
                                    </span>
                                </div>
                                <div class="form-group input-group field">
                                    <input
                                        v-model="password"
                                        id="login-password"
                                        autocomplete="off"
                                        placeholder="Password"
                                        type="password"
                                        class="form-control input-group js-input-password"
                                        v-validate="'required'"
                                        :class="{'input': true, 'danger': errors.has('password') }"
                                        name="password"
                                    >
                                    <span v-show="errors.has('password')" class="vv-error-message">
                                        {{ errors.first('password') }}
                                    </span>
                                </div>
                            </div>
                            <div class="acc-form">
                                <div class="checkbox checkbox-purple">
                                    <input id="checkbox4" type="checkbox">
                                    <label for="checkbox4" class="text-white text-normal">
                                        Remember me
                                    </label>
                                </div>
                                <div>
                                    <a @click="forgotPassword()" class="text-purple pointer">Forgot password?</a>
                                </div>
                            </div>
                            <div class="acc-form register-btn">
                                <button :class="isLogging && 'disable-element'" class="btn btn-white btn-outline" type="submit" :disabled="isLogging">
                                    {{ isLogging ? 'LOGGING IN...': 'SIGN IN' }}
                                </button>
                                <a :class="isLogging && 'disable-element'" class="btn btn-white btn-outline" :disabled="isLogging" @click="onSignUp()">SIGN UP
                                </a>
                            </div>

                            <div class="acc-form social-btn">
                                <a :class="isLogging && 'disable-element'" :href="`${googleSocialLoginUrl}?continue=${returnUrl}`" class="btn btn-gmail"> <i class="gplus" /> <span>Sign in with Google</span></a>
                                <a :class="isLogging && 'disable-element'" :href="`${fbSocialLoginUrl}?continue=${returnUrl}`" class="btn btn-facebook"> <i class="facebook" /> <span>Sign in with Facebook</span></a>
                            </div>
                        </div>
                        <div class="modal-footer bg-white">
                            <img src="/images/icons/nzxt-logos.png" alt="NZXT logos">
                            <p class="m-t m-b-0">
                                BY SIGNING UP OR LOGGING IN, YOU AGREE TO NZXT, CAM, AND BLD'S
                                <a href="https://www.nzxt.com/terms-of-service" class="text-purple" target="_blank">TERMS & CONDITIONS</a>
                                AND <a href="https://www.nzxt.com/privacy-policy" class="text-purple" target="_blank">PRIVACY POLICY</a>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </modal>
</template>

<script>
import { mapState } from "vuex";
import { Validator } from "vee-validate";
import { clearUserData, loginSuccessHandler } from "@/util/helpers";
import { gtmTrack } from "@/util/gtm";

export default {
    name: "LoginModal",
    data() {
        return {
            returnUrl: process.env.MIX_URL,
            googleSocialLoginUrl: process.env.MIX_NZXT_GOOGLE_SOCIAL_LOGIN,
            fbSocialLoginUrl: process.env.MIX_NZXT_FB_SOCIAL_LOGIN,
            email: "",
            password: "",
            showPassword: false,
            user: {},
            isLogging: false,
            error: "",
            shouldSaveBuildOnClose: false
        }
    },
    computed: {
        ...mapState({
            countryCode: state => state.User.location.country_code
        })
    },
    mounted() {
        const dictionary = {
            en: {
                custom: {
                    password: {
                        required: "Please enter in password."
                    },
                    email: {
                        email: "You did not enter in a valid email address. Please try again.",
                        required: "You must enter in your email address in order to register."
                    }
                }
            }
        };

        Validator.localize(dictionary);

        EventBus.$on("user-signed-in", user => {
            this.successHandler(user);
            this.$modal.hide("sign-up-modal");
        });

        EventBus.$on("session-expired", () => {
            this.$modal.show('login-modal');
        });
    },
    methods: {
        beforeOpen(event) {
            this.cleanUpFields();

            this.shouldSaveBuildOnClose = event.params ? event.params.shouldSaveBuildOnClose : false;

            clearUserData();
        },
        onSignUp() {
            this.$modal.hide('login-modal');
            this.$modal.show('sign-up-modal');
        },
        cleanUpFields() {
            this.email = "";
            this.username = "";
            this.password = "";
            this.error = "";
            this.$validator.reset();
            this.showPassword = false;
        },
        goTo(url) {
            this.$modal.hide("login-modal");
            this.$router.push(url);
        },
        async login() {
            this.isLogging = true;

            const isValid = await this.$validator.validateAll();

            if (!isValid) {
                this.isLogging = false;
                return;
            }

            const formData = new FormData();
            formData.append('email', this.email);
            formData.append('password', this.password);
            axios({
                url: "/auth/login",
                method: "POST",
                data: formData
            }).then(user => {
                if (user.data.message) {
                    this.errorHandler(user.data);
                } else {
                    this.successHandler(user.data);
                }
            }).catch(error => {
                this.error = error.message;
            }).then(() => this.isLogging = false)
        },
        async successHandler(user) {
            this.user = user;
            this.error = "";

            const ssoImg = new Image();
            ssoImg.src = user.ssoUrl;
            const storeImg = new Image();
            storeImg.src = user.multipasslogin;

            _learnq.push(['track', 'Signed In']);
            this.$modal.hide("login-modal");

            loginSuccessHandler(user);
            await this.$store.dispatch("saveUserData", user);

            gtmTrack.userSession(this.countryCode);

            if (this.shouldSaveBuildOnClose) {
                EventBus.$emit("save-build");
            }
            // If the user is forced to get logged in we use the section that tried to accesses
            if (this.$route.query.redirect) {
                this.$router.push(this.$route.query.redirect)
            }
        },
        errorHandler(error) {
            // TODO: Change this message in the backend to be equals to the production page
            this.error = error.message;

            $("#login-password").focus();
        },
        closeLoginModal() {
            this.$modal.hide("login-modal");
        },
        forgotPassword() {
            this.closeLoginModal();
            this.$router.push({ name: 'forgot-password' });
        }
    }
}
</script>

<style lang="scss">
.v--modal-overlay[data-modal="login-modal"] {
    background-color: rgba(0, 0, 0, 0.65);

    .v--modal-box {
        background-color: transparent;
        max-width: 100%;
    }

    .v--modal {
        background-color: transparent;
        box-shadow: none;
    }

    .vv-error-message {
        font-size: 13px;
        line-height: 20px;
        text-align: left;
        color: red;
    }

    #log-in-modal {
        padding: 0 15px !important;

        .modal-body {
            @media screen and (max-width: 450px) {
                padding: 0 30px 30px;
            }
        }
    }

    .modal-dialog {
        top: -130px;
        @media screen and (max-width: 680px) and (min-width: 320px) {
            top: -46px !important;
        }
    }
}

</style>
